export default __webpack_public_path__ + "static/media/red-cross.be72ee19.svg";